// extracted by mini-css-extract-plugin
export default {"addAPlanLink":"_1YrdcmvLetOGrcwMalMWJP"};